import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@uw/core/services/auth.service';
import { PostLoginNavigationComponent } from '../../components/post-login-navigation.component';
import { CampaignService } from '@uw/core/services/campaign.service';
import { CustomNavigationService } from '@uw/core/custom-navigation.service';
import { AuthResponse } from '../../models/auth-response';
import { ChangePasswordFormData } from '../../models';
import { LoginContentContainerComponent } from '../../../../shared/components/login-content-container/login-content-container.component';
import { ChangePasswordFormComponent } from '../change-password-form/change-password-form.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    templateUrl: './password-expired.component.html',
    styleUrls: ['./password-expired.component.scss'],
    imports: [LoginContentContainerComponent, ChangePasswordFormComponent, TranslateModule]
})
export class PasswordExpiredComponent
  extends PostLoginNavigationComponent
  implements OnInit
{
  readonly currentLanguage = this.translateService.currentLang;

  readonly authResponse: AuthResponse;

  readonly passwordResetToken: string;

  buttonLoading = false;

  constructor(
    protected _authService: AuthService,
    _campaignService: CampaignService,
    customNavigationService: CustomNavigationService,
    _router: Router
  ) {
    super(_authService, _campaignService, customNavigationService);
    const pageState = _router.getCurrentNavigation()?.extras.state;
    this.passwordResetToken = pageState && pageState.passwordResetToken;
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  onChangePassword(changePasswordFormData: ChangePasswordFormData): void {
    const { newPassword: password, currentPassword: _oldPasword } =
      changePasswordFormData;

    this.buttonLoading = true;
    this.authService.resetExpiredPassword({ password, passwordResetToken: this.passwordResetToken }).subscribe(
      (authResponse) => {
        if (authResponse) {
          this.buttonLoading = false;
          this.showSuccess('change_password.password_updated_msg');

          this.navigateToPostLoginLoginDestinationPage(authResponse);
        }
      },
      (err) => {
        this.buttonLoading = false;
        this.errorMessage =
          err && err.message && err.message == 'cannot_reuse_password'
            ? this.translateService.instant(
                'change_password.error.code.cannot_reuse_password'
              ) :
              this.translateService.instant('messages.password_update_failed');
      }
    );
  }

  onPasswordChangeSuccess() {
    this.navigateToPostLoginLoginDestinationPage({
      ...this.authResponse,
      passwordExpired: false,
    });
  }
}
